module.exports = __webpack_public_path__ + "static/s-6-0c208c1f807c7e75455d316b55c27c2f.svg";